import { formatUploadDateRange, formatUploadTimestamp } from "./validationDisplay";

export const IMPORT_STATUSES = ["Processing", "Completed", "Completed with Errors", "Failed"];

export const getImportStatusClass = (status) => {
	switch (status) {
		case "Processing":
			return "importStatusProcessing";
		case "Completed":
			return "importStatusCompleted";
		case "Completed with Errors":
			return "importStatusWarning";
		case "Failed":
			return "importStatusFailed";
		default:
			return "importStatusNeutral";
	}
};

export const formatUploadHistoryDate = (value) => formatUploadTimestamp(value) || "—";

export const formatUploadHistoryCardDate = (value) => {
	if (!value) return "—";
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "—";

	const datePart = date.toLocaleDateString("en-US", {
		day: "numeric",
		month: "short",
		year: "numeric",
	});
	const timePart = date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
	});

	return `${datePart} · ${timePart}`;
};

export const formatUploadRecordCount = (value) => {
	const count = Number(value);
	if (!Number.isFinite(count) || count <= 0) return "0";
	return count.toLocaleString("en-US");
};

export const formatServiceDateRange = (start, end) => formatUploadDateRange(start, end) || "—";

export const formatCountCell = (value) => {
	const count = Number(value);
	return Number.isFinite(count) ? count.toLocaleString("en-US") : "—";
};

export const buildUploadHistoryQuery = ({ endDate, page, rowsPerPage, startDate, status, uploadedBy }) => {
	const params = {
		limit: rowsPerPage,
		page,
	};

	if (status) params.status = status;
	if (uploadedBy) params.uploadedBy = uploadedBy;
	if (startDate) params.startDate = startDate;
	if (endDate) params.endDate = endDate;

	return params;
};
